import { colors } from '@tabbio/tokens';
import { useTheme } from '@/hooks/useTheme';
import type { WritingLevelValue } from '@/lib/subscription-journey/plan-presentation';

/** Web twin of WritingLevel.tsx: bars are aria-hidden, the label is the meaning. */
export function WritingLevel({ level, label }: { level: WritingLevelValue; label: string }) {
  const { theme } = useTheme();
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 11,
        lineHeight: '14px',
        color: theme.textTertiary,
        whiteSpace: 'nowrap',
      }}
    >
      <span aria-hidden style={{ display: 'inline-flex', gap: 2, flexShrink: 0 }}>
        {[1, 2, 3].map((bar) => (
          <span
            key={bar}
            style={{
              width: 11,
              height: 5,
              borderRadius: 2,
              background: bar <= level ? colors.primary : theme.surfaceTertiary,
            }}
          />
        ))}
      </span>
      <span>{label}</span>
    </span>
  );
}
